import { render } from "./Workspace.vue?vue&type=template&id=7e6b900e"
import script from "./Workspace.vue?vue&type=script&lang=js"
export * from "./Workspace.vue?vue&type=script&lang=js"

import "./Workspace.vue?vue&type=style&index=0&id=7e6b900e&lang=css"
script.render = render

export default script